export default __webpack_public_path__ + "static/media/MilnasTransparent.13a1e8da.png";